import { Modal } from 'antd';
import React from 'react';

import { CANCEL, SAVE } from '@app/constants';
import type { NTasksList } from '@app/pages/TasksList/types/TasksList.types';

export const FinishTaskModal: React.FC<NTasksList.FinishTaskModalProps> = ({
  isOpen,
  onCancel,
  onSave,
  isLoading,
}) => (
  <Modal
    open={isOpen}
    title="Завершение задач"
    okText={SAVE}
    cancelText={CANCEL}
    onCancel={onCancel}
    onOk={onSave}
    okButtonProps={{ loading: isLoading }}
    cancelButtonProps={{ disabled: isLoading }}
  >
    Вы уверены, что хотите завершить выбранные задачи?
  </Modal>
);
